import React from 'react';
import Head from 'next/head';
import { useTenantConfig } from '../contexts/GlobalDataContext';

interface HeadSectionProps {
  title?: string;
  description?: string | false;
  keywords?: string;
  image?: string;
  canonical?: string;
  noindex?: boolean;
}
export const HeadSection: React.FC<HeadSectionProps> = ({
  title,
  description,
  keywords,
  image,
  canonical,
  noindex = false,
}: HeadSectionProps) => {
  const { meta } = useTenantConfig();
  return (
    <Head>
      <title>{title || meta.title}</title>
      <meta name="title" content={title || meta.title} />
      <meta property="og:title" content={title || meta.title} />
      {description !== false && (
        <meta name="description" content={description || meta.description} />
      )}
      {keywords && <meta name="keywords" content={keywords} />}
      {description !== false && (
        <meta
          property="og:description"
          content={description || meta.description}
        />
      )}
      <meta name="image" content={image || meta.image} />
      <meta property="og:image" content={image || meta.image} />
      {noindex && <meta name="robots" content="noindex" />}
      {canonical && <link rel="canonical" href={canonical} />}
    </Head>
  );
};
